module.exports = __webpack_public_path__ + "dist/media/norge-vizeay.b4613bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/team/norge-vizeay.png
// module id = 387
// module chunks = 0